import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'gb-mastercard-icon',
  templateUrl: './gb-mastercard-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbMastercardIconComponent {
  @Input() darkTheme = false
}
